import React from 'react';
import { AppGridLayout, AppTable, AppButton, AppGridBar, AppRow, AppAction } from 'qcc';
import api, { ErpProjectOutput } from 'api';
interface Props {
  erpProjectOutput?: ErpProjectOutput[],
  organId: number,
  afterSave:()=>void
}
export default class extends React.Component<Props>{
  getErpProjectList = async () => {
    let itemList = this.refTable.current.getSelected();
    await api.mdmproject.getErpProjectList({ "erpProjectOutputList": itemList, "organId": this.props.organId });
    this.props.afterSave && this.props.afterSave()
  }
  refGrid = React.createRef<AppGridLayout>();
  refTable = React.createRef<AppTable>();
  render() {
    return (
      <AppGridLayout ref={this.refGrid}>
        <AppGridLayout.MenuArea>
          <AppGridBar>
            <AppGridBar.Right>
              <AppButton label='同步主数据' actionCode="00020104" type='primary' action={this.getErpProjectList} />
            </AppGridBar.Right>
          </AppGridBar>
        </AppGridLayout.MenuArea>
        <AppGridLayout.GridArea>
          <AppTable dataSource={this.props.erpProjectOutput} ref={this.refTable} keyName='posId'>
            <AppTable.ColCheckbox />
            <AppTable.Col title='项目名称' field='post1' width={300} />
          </AppTable>
        </AppGridLayout.GridArea>
      </AppGridLayout>
    )
  }

}


// WEBPACK FOOTER //
// ./src/page/mdm/project/ProjectSelectTable.tsx